// Synced with backend SOCIAL_LOGIN_* constants
export var SocialLoginProvider = /*#__PURE__*/ function(SocialLoginProvider) {
    SocialLoginProvider[SocialLoginProvider["Google"] = 4] = "Google";
    SocialLoginProvider[SocialLoginProvider["Apple"] = 7] = "Apple";
    SocialLoginProvider[SocialLoginProvider["Facebook"] = 8] = "Facebook";
    SocialLoginProvider[SocialLoginProvider["Test"] = 5] = "Test";
    return SocialLoginProvider;
}({});

//# sourceMappingURL=types.js.map